export default __webpack_public_path__ + "static/media/bandan_font.79c86178.png";